// extracted by css-extract-rspack-plugin
export default {"JoinStrategyIcon":"vY9CR","JoinStrategyList":"JstFS"};